<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div
          class="card_container"
          style="border-radius: 17px"
          :style="{
            backgroundImage: `url(${cardBackgroundUrl})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right',
            backgroundSize: ' 136px',
          }"
        >
          <div class="card__header___text">
            <div>
              <h3 class="our_branches__header">
                {{ $t("text.bWallet.totalAmountSpent") }}
              </h3>
              <div class="dealer__icon__wrapper mt-3">
                <div class="dealer__icon__div text-center">
                  <div>
                    <img src="@/assets/img/wallet.svg" width="35px" />
                  </div>
                </div>
              </div>
              <div class="text-center mt-3">
                <h3>
                  {{ group ? group.currencyCode : "" }} {{ totalAmountSpent }}
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div
          class="fuelbalance_first_row_right_section mr-3 co_dealer"
          style="border-radius: 22px"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="our__branches__banner">
            <div class="row align-items-center section__row">
              <div class="col-md-4 text-center section___column_1">
                <h3 class="our__branches__banner__title">
                  {{ $t("text.bWallet.title") }} ({{ walletCount }})
                </h3>
              </div>
              <div class="col-md-4 drop_down_input_group">
                <div class="drop_down_section mt-2 mr-2">
                  <div class="drop_down_div align-items-center">
                    <vue-ctk-date-time-picker
                      v-model="dateRange"
                      :max-date="maxDate"
                      :range="true"
                      :autoClose="true"
                      :locale="this.$root.$i18n.locale"
                      :custom-shortcuts="customShortcuts"
                      :color="$store.getters.getDatePickerColor"
                      format="DDMMYYYY"
                      formatted="DD/MM/YYYY"
                      :label="$t('text.calendar.dateRange')"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-4 drop_down_input_group">
                <select class="bg-white mt-2 mr-2" v-model="salesType">
                  <option value="" selected>
                    {{ $t("text.salesTransactions.showAll") }}
                  </option>
                  <option
                    :value="sale.value"
                    v-for="(sale, index) in saleType"
                    :key="index"
                  >
                    <span>
                      {{ sale.name }}
                    </span>
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="section__row mt-3">
        <div class="">
          <div class="">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :excelQueryCellInfo="excelQueryCellInfo"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="40px" field="index" headerText="#"></e-column>
                <e-column
                  field="date"
                  width="200"
                  :format="formatOptions"
                  type="date"
                  :headerText="$t('text.bWallet.date')"
                ></e-column>
                <e-column
                  width="180"
                  field="salesType"
                  :headerText="$t('text.bWallet.salesType')"
                ></e-column>
                <e-column
                  width="180"
                  field="identifier"
                  :headerText="$t('text.bWallet.identifier')"
                ></e-column>
                <e-column
                  width="180"
                  field="pump"
                  :headerText="$t('text.cDisconnectedPumps.pump')"
                ></e-column>
                <e-column
                  format="N2"
                  field="amount"
                  width="200"
                  :headerText="`${$t('text.bWallet.amountSpent')} (${
                    group ? group.currency : ''
                  })`"
                ></e-column>
                <e-column
                  field="product"
                  width="180"
                  :headerText="$t('text.bWallet.product')"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <div
              v-show="!showLoader"
              v-if="
                totalAmountSpent > 0 ||
                !userDetails.roles.includes('viewESales')
              "
            >
              <table class="table table-bordered">
                <tbody>
                  <tr>
                    <th scope="row" class="text-right">
                      {{ $t("text.sales.totalSales") }}
                    </th>
                    <td>
                      {{ group ? group.currencyCode : "" }}
                      {{ totalAmountSpent }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import MasterLayout from "@/views/groupManagement/MasterLayout.vue";
import backgroundUrl from "@/assets/img/BecomeDealer.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  // Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "GroupWallet",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      formatOptions: { type: "date", format: "dd/MM/yyyy hh:mm a" },
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      startDate: this.$moment().format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      group: {},
      groupId: null,
      backgroundUrl,
      totalAmountSpent: 0,
      cardBackgroundUrl,
      showLoader: false,
      walletBalance: 0,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Print", "Search"],
      search: { operator: "contains", ignoreCase: true },
      userDetails: JSON.parse(localStorage.getItem("userDetails")),
      // saleType: ["Card", "USSD", "Voucher", "Remis", "POS", "Retainership"],
      saleType: [
        { name: this.$t("text.iFundWallet.card"), value: "Card" },
        { name: this.$t("text.general.ussd"), value: "USSD" },
        { name: this.$t("text.cusMasterLayout.voucher"), value: "Voucher" },
        { name: this.$t("text.fundWallet.remis"), value: "Remis" },
        // { name: this.$t("text.endOfDayReport.pos"), value: "POS" },
        {
          name: this.$t("text.cMasterLayout.retainership"),
          value: "Retainership",
        },
      ],
      salesType: "",
      walletCount: 0,
    };
  },
  created() {
    if (localStorage.getItem("userDetails") === "null") {
      this.$router.push({ path: "/" });
    } else if (configObject.authConfig() === null) {
      window.location.reload();
    }
    // console.log(this.userDetails.roles.includes("viewESales"));
    this.showLoader = true;
    this.$eventHub.$on("group", (group) => {
      this.group = group;
      document.title = `Group Wallet:: ${branch.name} Group`;
    });

    if (this.$route.query.startDate && this.$route.query.endDate) {
      this.dateRange.start = this.$moment(this.$route.query.startDate).format(
        "D-M-YYYY"
      );
      this.dateRange.end = this.$moment(this.$route.query.endDate).format(
        "D-M-YYYY"
      );
    } else {
      this.dateRange.start = this.pluginStartDate;
      this.dateRange.end = this.pluginEndDate;

      this.$router.replace({
        name: this.$route.name,
        query: {
          groupId: this.$route.query.groupId
            ? this.$route.query.groupId
            : this.group.id,
          companyId: this.$route.query.companyId,
          startDate: this.$moment(this.pluginStartDate, "DD-MM-YYYY").format(
            "MMMM D, YYYY"
          ),
          endDate: this.$moment(this.pluginEndDate, "DD-MM-YYYY").format(
            "MMMM D, YYYY"
          ),
        },
      });
    }

    // this.dateRange.start = this.pluginStartDate;
    // this.dateRange.end = this.pluginEndDate;

    document.title = `Retail Outlet Wallet:: Epump Retail Outlet`;
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  watch: {
    group: function (newgroup, oldgroup) {
      if (newgroup.id) {
        this.groupId = this.group.id;
        if (this.groupId !== null) {
          this.getESales();
          $(".e-input").keyup(function (e) {
            searchFun(e);
          });
          function searchFun(event) {
            var grid =
              document.getElementsByClassName("e-grid")[0].ej2_instances[0];
            var value = event.target.value;
            grid.search(value);
          }
        }
      }
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.$router.replace({
          name: this.$route.name,
          query: {
            groupId: this.$route.query.groupId
              ? this.$route.query.groupId
              : this.group.id,
            companyId: this.$route.query.companyId,
            startDate: this.startDate,
            endDate: this.endDate,
          },
        });

        this.getESales();
      }
    },
    salesType(st) {
      if (st !== null) {
        this.getESales();
        // console.log("sales type");
      }
    },
  },
  beforeDestroy() {},
  mounted() {},
  methods: {
    excelQueryCellInfo(args) {
      if (args.column.field == "date") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY");
      }
    },

    toolbarClick(args) {
      let currency = this.group.currencyCode ? this.group.currencyCode : "₦";

      let productAggregate = [
        ...this.productAggregate.map((item, index) => {
          return {
            type: "Text",
            value: `${item.product.toUpperCase()}: ${item.totalSale.toLocaleString()}`,
            position: { x: index * 150, y: 30 },

            style: {
              textBrushColor: "#000000",
              fontSize: 17,
              bold: true,
              textAlign: "center",
            },
          };
        }),

        {
          type: "Text",
          value: `Total Sales: ${this.totalAmountSpent} `,
          position: { x: this.productAggregate.length * 150, y: 30 },
          style: {
            textBrushColor: "#000000",
            fontSize: 17,
            bold: true,
            textAlign: "center",
          },
        },
      ];
      // console.log(productAggregate, "kkk");
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: `${this.group.name} - Esales Report.pdf`,
            header: {
              fromTop: 0,
              height: 60,
              contents: [
                {
                  type: "Text",
                  value: `${this.group.name} - Esales Report`,
                  position: { x: 0, y: -1 },
                  style: {
                    textBrushColor: "#000000",
                    fontSize: 20,
                    bold: true,
                    textAlign: "center",
                  },
                },

                ...productAggregate,
                // {
                //   type: "Text",
                //   value: `Total Sales: ${this.totalAmountSpent} `,
                //   position: { x: 0, y: 20 },
                //   style: {
                //     textBrushColor: "#000000",
                //     fontSize: 17,
                //     bold: true,
                //     textAlign: "center",
                //   },
                // },
              ],
            },
          };
          this.$refs.dataGrid.getColumns()[0].width = "50";
          this.$refs.dataGrid.getColumns()[1].width = "140";
          this.$refs.dataGrid.getColumns()[2].width = "140";
          this.$refs.dataGrid.getColumns()[3].width = "180";
          this.$refs.dataGrid.getColumns()[4].width = "150";
          this.$refs.dataGrid.getColumns()[5].width = "180";
          this.$refs.dataGrid.getColumns()[6].width = "120";
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          let excelExport = {
            fileName: `${this.group.name} - Esales Report.xlsx`,
          };
          this.$refs.dataGrid.excelExport(excelExport);
          break;
        case "Print":
          this.$refs.dataGrid.print();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    getESales() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Voucher/SalesRepESales/${
            this.groupId
          }?salesType=${this.salesType}&startDate=${
            this.$route.query.startDate
              ? this.$route.query.startDate
              : this.startDate
          }&endDate=${
            this.$route.query.endDate ? this.$route.query.endDate : this.endDate
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          // this.walletBalance = response.data.balance;
          let index = 0;
          let esales = response.data;
          this.totalAmountSpent = esales
            .reduce((a, b) => {
              return a + b.amount;
            }, 0)
            .toLocaleString();

          this.productAggregate = esales.reduce((acc, current) => {
            let product = acc.find((p) => p.product === current.product);
            if (!product) {
              acc.push({ product: current.product, totalSale: current.amount });
            } else {
              product.totalSale += current.amount;
            }
            return acc;
          }, []);

          esales.forEach((element) => {
            element.index = ++index;
            element.date = this.$moment(element.date).format("lll");
            // element.product = element.product.toUpperCase();
            if (element.salesType == "") {
              element.salesType = this.$t("text.general.na");
            }
            if (element.pump == null) {
              element.pump = this.$t("text.general.na");
            }
            if (element.product == null) {
              element.product = this.$t("text.general.na");
            } else {
              element.product = element.product.toUpperCase();
            }
            if (element.identifier == "") {
              element.identifier = this.$t("text.general.na");
            }
          });
          // wallet count
          this.walletCount = esales.length;
          //lets try making it dynamic
          // let prods = response.data.esales.reduce((acc, curr) => {
          //   if (acc.indexOf(curr.salesType) < 0) {
          //     acc.push(curr.salesType);
          //   }
          //   return acc;
          // }, []);
          // this.saleType = prods.sort();

          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: esales,
          });
          this.refreshGrid();
        })
        .catch((error) => {});
    },
    decimalThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
